/* eslint-disable react/react-in-jsx-scope */
import './App.css';
import MainPage from './components/MainPage';
import Shopping from './components/Shopping';
import { Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/test" element={<Shopping />} />
      </Routes>
    </div>
  );
}

export default App;

